import { Component, OnInit } from '@angular/core';
import {NavService} from "../../../services/nav.service";

@Component({
  selector: 'app-video-chat-complete',
  templateUrl: './video-chat-complete.page.html',
  styleUrls: ['./video-chat-complete.page.scss'],
})
export class VideoChatCompletePage implements OnInit {

  constructor(
      private nav: NavService,
  ) {}

  ngOnInit() {
  }

  goHome() {
    this.nav.navigateRoot(['/home']);
  }

}
